import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=04e871d2&lang=html&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "../spreadsheet/kendoui/kendo.common.min.css?vue&type=style&index=0&lang=css&"
import style1 from "../spreadsheet/kendoui/kendo.default.min.css?vue&type=style&index=1&lang=css&"
import style2 from "../spreadsheet/kendoui/kendo.default.mobile.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/editor/Editor.vue
// module id = 1508
// module chunks = 28